import { CanDeactivateFn } from '@angular/router';

/**
 * Component contract for routes guarded by `unsavedChangesGuard`:
 *   - `hasUnsavedChanges()` returns true if the form is dirty.
 *   - `confirmDiscard()` returns a Promise<boolean> (typically resolved by a MatDialog confirm).
 *
 * The guard reads the contract via duck typing — no shared interface needed.
 */
export interface UnsavedChangesAware {
  hasUnsavedChanges(): boolean;
  confirmDiscard(): Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (component) => {
  if (!component?.hasUnsavedChanges?.()) {
    return true;
  }
  return component.confirmDiscard();
};
